












import { Vue, Component, Prop } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import S3Uploader from "@/shared/components/s3Uploader.vue";
import S3ResponseReader from "@/shared/components/s3ResponseReader.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployeeStore } from "@/employer/store/employee";

@Component({
  components: { S3Uploader, S3ResponseReader }
})
export default class GeneralInformation extends Vue {
  $validator: Validator;

  notifierStore = useNotifierStore();
  employeeStore = useEmployeeStore();

  @Prop()
  watchedFile: string;
  @Prop()
  bucketName: string;

  created () {
    this.employeeStore.clear();
  }

  onResponseFileLoaded () {
    this.employeeStore.clear();
  }

  get outKey () {
    return `census/$identityid/out/${this.watchedFile}.json`;
  }

  handleError (err: any): void {
    this.notifierStore.setDanger(err || "Error processing your request. Please try again later");
  }
}
